import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _287a663b = () => interopDefault(import('../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _374c97a2 = () => interopDefault(import('../pages/deliveries/index.vue' /* webpackChunkName: "pages/deliveries/index" */))
const _91618994 = () => interopDefault(import('../pages/invoices/index.vue' /* webpackChunkName: "pages/invoices/index" */))
const _3e51c5a8 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _f1c4de52 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _ce9dc6ea = () => interopDefault(import('../pages/server-error.vue' /* webpackChunkName: "pages/server-error" */))
const _163cb584 = () => interopDefault(import('../pages/integrations/add.vue' /* webpackChunkName: "pages/integrations/add" */))
const _0756b1e7 = () => interopDefault(import('../pages/integrations/update/_id.vue' /* webpackChunkName: "pages/integrations/update/_id" */))
const _71ffcaec = () => interopDefault(import('../pages/deliveries/_id.vue' /* webpackChunkName: "pages/deliveries/_id" */))
const _8682d9c4 = () => interopDefault(import('../pages/invoices/_id.vue' /* webpackChunkName: "pages/invoices/_id" */))
const _d32efc72 = () => interopDefault(import('../pages/sso/_token.vue' /* webpackChunkName: "pages/sso/_token" */))
const _172f7a15 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _287a663b,
    name: "404"
  }, {
    path: "/deliveries",
    component: _374c97a2,
    name: "deliveries"
  }, {
    path: "/invoices",
    component: _91618994,
    name: "invoices"
  }, {
    path: "/login",
    component: _3e51c5a8,
    name: "login"
  }, {
    path: "/logout",
    component: _f1c4de52,
    name: "logout"
  }, {
    path: "/server-error",
    component: _ce9dc6ea,
    name: "server-error"
  }, {
    path: "/integrations/add",
    component: _163cb584,
    name: "integrations-add"
  }, {
    path: "/integrations/update/:id?",
    component: _0756b1e7,
    name: "integrations-update-id"
  }, {
    path: "/deliveries/:id",
    component: _71ffcaec,
    name: "deliveries-id"
  }, {
    path: "/invoices/:id",
    component: _8682d9c4,
    name: "invoices-id"
  }, {
    path: "/sso/:token?",
    component: _d32efc72,
    name: "sso-token"
  }, {
    path: "/",
    component: _172f7a15,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
